import regions from '@/configuration/regions'

let endDevicesCsvHeaders = {
  devEui: {
    required: true,
    length: 16,
    format: 'a-endDevicesImport:bulk.devEui'
  },
  clusterId: {
    required: true,
    format: 'a-endDevicesImport:bulk.clusterId'
  },
  clusterName: {
    format: 'a-endDevicesImport:bulk.clusterName'
  },
  name: {
    format: 'a-endDevicesImport:bulk.name',
    maxLength: 255
  },
  classType: {
    required: true,
    format: 'a-endDevicesImport:bulk.classType'
  },
  rfRegion: {
    required: true,
    values: regions.regions,
    format: 'a-endDevicesImport:bulk.rfRegion'
  },
  country: {
    values: regions.countries,
    format: 'a-endDevicesImport:bulk.country'
  },
  macVersion: {
    required: true,
    values: regions.macVersions,
    format: 'a-endDevicesImport:bulk.macVersion'
  },
  regParamsRevision: {
    required: true,
    values: regions.regionalParameterRevisions,
    format: 'a-endDevicesImport:bulk.regParamsRevision'
  },
  profile: {
    required: true,
    values: ['STATIC', 'WALKING', 'VEHICLE'],
    format: 'a-endDevicesImport:bulk.profile'
  },
  adrEnabled: {
    format: 'a-endDevicesImport:bulk.adrEnabled'
  },
  activation: {
    required: true,
    values: ['OTAA', 'ABP'],
    format: 'a-endDevicesImport:bulk.activation'
  },
  devAddr: {
    length: 8,
    format: 'a-endDevicesImport:bulk.devAddr'
  },
  appEui: {
    length: 16,
    format: 'a-endDevicesImport:bulk.appEui'
  },
  appKey: {
    length: 32,
    format: 'a-endDevicesImport:bulk.appKey'
  },
  appSKey: {
    length: 32,
    format: 'a-endDevicesImport:bulk.appSKey'
  },
  nwkSKey: {
    length: 32,
    format: 'a-endDevicesImport:bulk.nwkSKey'
  },
  fcntDown: {
    format: 'a-endDevicesImport:bulk.fcntDown'
  },
  fcntUp: {
    format: 'a-endDevicesImport:bulk.fcntUp'
  },
  devNonceCounter: {
    format: 'a-endDevicesImport:bulk.devNonceCounter'
  },
  fNwkSIntKey: {
    length: 32,
    format: 'a-endDevicesImport:bulk.fNwkSIntKey'
  },
  sNwkSIntKey: {
    length: 32,
    format: 'a-endDevicesImport:bulk.sNwkSIntKey'
  },
  rx1Delay: {
    format: 'a-endDevicesImport:bulk.rx1Delay',
    min: 0,
    max: 15
  },
  rx1DrOffset: {
    format: 'a-endDevicesImport:bulk.rx1DrOffset',
    min: 0,
    max: 7
  },
  rx2Dr: {
    format: 'a-endDevicesImport:bulk.rx2Dr',
    min: 0,
    max: 15
  },
  rx2Freq: {
    format: 'a-endDevicesImport:bulk.rx2Freq',
    min: 0
  },
  rxWindows: {
    values: ['RX1', 'RX2', 'RX3'],
    format: 'a-endDevicesImport:bulk.rxWindows'
  },
  cfList: {
    format: 'a-endDevicesImport:bulk.cfList'
  },
  dwellTime: {
    format: 'a-endDevicesImport:bulk.dwellTime'
  },
  pingSlotDr: {
    format: 'a-endDevicesImport:bulk.pingSlotDr'
  },
  pingSlotFreq: {
    format: 'a-endDevicesImport:bulk.pingSlotFreq'
  },
  geolocation: {
    required: true,
    values: ['MANUAL', 'INHERITED'],
    format: 'a-endDevicesImport:bulk.geolocation'
  },
  latitude: {
    format: 'a-endDevicesImport:bulk.latitude',
    min: -90,
    max: +90
  },
  longitude: {
    format: 'a-endDevicesImport:bulk.longitude',
    min: -180,
    max: +180
  },
  altitude: {
    format: 'a-endDevicesImport:bulk.altitude'
  },
  status: {
    format: 'a-endDevicesImport:bulk.status'
  },
  lastDataUpMessage: {
    format: 'a-endDevicesImport:bulk.lastDataUpMessage'
  },
  lastDataDownMessage: {
    format: 'a-endDevicesImport:bulk.lastDataDownMessage'
  },
  lastDataUpDr: {
    format: 'a-endDevicesImport:bulk.lastDataUpDr'
  }
}

// Export module
export default endDevicesCsvHeaders
